
import { schema } from "./types";
import { OverviewPanel,OperatorPanel } from '.';
import { IAutomationAppComponent } from "../../types";
import { AiOutlinePercentage } from "react-icons/ai";



export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: AiOutlinePercentage,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
  
}